'use client';

import { PageLoadTypes } from '@next-app/constants/constants';
import { getFromSessionStorage } from '@next-app/utils/session-storage-utils';
import {
  selectInitResponse,
  selectSessionInfo,
  selectUserProfile,
} from '@next-app/lib/features/InitSelectors';
import { DynamicDTMEvent } from '@next-app/utils/dtm-event';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

interface SelectedFacetInterface {
  name?: string;
  values?: string[];
}

interface SRPPageLoadInterface {
  facets?: SelectedFacetInterface[];
  pageNo: number;
  searchTerm: string;
  sortType: string;
  top15Products: [string][];
  topProducts: [string][];
  searchEnteredText: string;
}

const SRPPageLoadDTM = (props: SRPPageLoadInterface) => {
  const initResp = useSelector(selectInitResponse);
  const sessionInfo = useSelector(selectSessionInfo);
  const userProfile = useSelector(selectUserProfile);
  const isEventFired = useRef(false);

  useEffect(() => {
    const pageLoadType = getFromSessionStorage('pageLoadType');
    const hasKeys =
      sessionInfo &&
      initResp &&
      Object.keys(sessionInfo)?.length > 0 &&
      Object.keys(initResp)?.length > 0;

    if (hasKeys && !isEventFired.current) {
      const pageLoadData = {
        event: 'pageLoadData',
        detail: {
          findingMethod: pageLoadType || 'internalSearch',
          pageType: 'search',
          pageSection: 'products',
          pageName: 'Search Products | Lakeshore&reg; Learning Materials',
          pageTitle: `Lakeshore Learning - Search Results for ${decodeURIComponent(props.searchTerm)}`,
          pageUrl: window.location.href,
          md5Email: userProfile.md5Email || '',
          recognized: userProfile?.loginStatus === 'recognized' || false,
          ...(userProfile.loginStatus !== 'guest' && {
            profileDetails: {
              dateOfBirth: userProfile.dateOfBirth,
              email: userProfile.email,
              firstName: userProfile.firstName,
              lastName: userProfile.lastName,
              isGsaUser: userProfile.gsaUser,
            },
          }),
          ...(userProfile.securityStatus && {
            securityStatus: userProfile.securityStatus,
          }),
          ...props,
          ...(pageLoadType === PageLoadTypes.Search_Box_Search_Term_Click && {
            suggestedSearchText: props.searchTerm,
            isSearchSuggest: true,
            searchEnteredText: getFromSessionStorage('searchEnteredText'),
          }),
          ...(pageLoadType === PageLoadTypes.Search_Box_Recent_Search_Click && {
            suggestedSearchText: props.searchTerm,
            isRecentSearchSuggest: true,
          }),
          cartCount: sessionInfo?.cartInfo?.cartQty,
          email: userProfile?.email || '',
          profileId: userProfile?.id,
          isFurniture: sessionInfo?.furniture,
          isGSAUser: userProfile?.gsaUser,
          llmAPIVersion: initResp?.internalAPI,
          rewardsUserStatus: sessionInfo?.rewardsCustomer?.tierInfo?.currentTier
            ? sessionInfo?.rewardsCustomer?.tierInfo?.currentTier
            : sessionInfo?.rewardsCustomer?.isRewardsMember &&
                userProfile?.securityStatus >= 4
              ? 'Signed In'
              : 'Guest',
          storeSelected:
            Object.keys(userProfile?.selectedStore).length > 0
              ? `${userProfile?.selectedStore?.city}, ${userProfile?.selectedStore?.state}`
              : '',
          userShopFor: userProfile?.userShopFor || '',
        },
      };
      window.sessionStorage.removeItem('searchEnteredText');
      window.sessionStorage.removeItem('pageLoadType');
      if (getFromSessionStorage('searchTermNtt')) {
        window.sessionStorage.removeItem('searchTermNtt');
      }
      DynamicDTMEvent(pageLoadData);
      isEventFired.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionInfo, initResp, props]);
  return null;
};

export default SRPPageLoadDTM;
